import { ApiResponse, CommonApiResponse } from "../Controllers/Types/ApiResponse";
import { ContactListResponse, ContactResponse, EmployeeCompanyDataResponse, EmployeePersonalDataResponse, RoleDataResponse } from "../Controllers/Types/ContactResponse";
import { baseURL } from "./ApiConstant";
import apiClient from "./apiClient";


/* ************************************************************  contact - part *****************************************************************/
export const contactCreateAPI = async (contact_type: string, contact_subtype: string, token: string): Promise<ContactResponse> => {
    try {
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/contact/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: JSON.stringify({ contact_type, contact_subtype }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, contactId: data.contact_id };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};


export const contactListAPI = async (): Promise<ContactListResponse> => {
    try {
        const token = localStorage.getItem('token') || ''
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/contact`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, data: data.data };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const contactDeleteAPI = async (contactId: number): Promise<CommonApiResponse> => {
    try {

        const token = localStorage.getItem('token')
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/contact/delete/${contactId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: JSON.stringify({}),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};
/* ************************************************************  contact - part *****************************************************************/


export const employeePersonalDataAPI = async (contact_id: number | null, first_name: string, last_name: string, email: string, mobile: string, landline: string, address: string, city: string, post_code: string, profile_image: File, token: string, area_id: number | null, password: string): Promise<EmployeePersonalDataResponse> => {
    try {
        const FULL_TOKEN = `Bearer ${token}`;
        /* create form data */
        const formData = new FormData();
        formData.append('contact_id', String(contact_id));
        formData.append('first_name', first_name);
        formData.append('last_name', last_name);
        formData.append('email', email);
        formData.append('mobile', mobile);
        formData.append('landline', landline);
        formData.append('address', address);
        formData.append('city', city);
        formData.append('post_code', post_code);
        if (profile_image) {
            formData.append('profile_image', profile_image);
        }

        if (area_id != null) {

            formData.append('area_id', String(area_id));
        }

        if (password !== '') {
            formData.append('password', password);
        }

        const response = await fetch(`${baseURL}/api/personal-info/create`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};


export const employeeCompanyDataAPI = async (contact_id: number, personal_email: string, personal_phone: string, name: string, regno: string, email: string, phone: string, address: string, city: string, post_code: string, landline: string, token: string): Promise<EmployeeCompanyDataResponse> => {
    try {
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/company-info/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: JSON.stringify({ contact_id, personal_email, personal_phone, name, regno, email, phone, address, city, post_code, landline }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};


export const roleCreateAPI = async (role_name: string, token: string): Promise<CommonApiResponse> => {
    try {
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/user-role/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: JSON.stringify({ role_name }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};


export const roleDataGetAPI = async (token: string): Promise<RoleDataResponse> => {
    try {
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/user-role`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, data: data.data };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};


export const employeeRoleDataAPI = async (contact_id: number, user_role_id: number, display_role_name: string, token: string): Promise<CommonApiResponse> => {
    try {
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/user-role-info/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: JSON.stringify({ contact_id, user_role_id, display_role_name }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};


export const subContactDataAPI = async (contact_id: number, employee_type: string, first_name: string, last_name: string, email: string, pimary_phone_no: string, secondary_phone_no: string, user_role_id: number, display_role_name: string, profile_image: File, token: string): Promise<CommonApiResponse> => {
    try {
        const FULL_TOKEN = `Bearer ${token}`;

        /* create form data */
        const formData = new FormData();
        formData.append('contact_id', String(contact_id));
        formData.append('employee_type', employee_type);
        formData.append('first_name', first_name);
        formData.append('last_name', last_name);
        formData.append('email', email);
        formData.append('pimary_phone_no', pimary_phone_no);
        formData.append('secondary_phone_no', secondary_phone_no);
        formData.append('user_role_id', String(user_role_id));
        formData.append('display_role_name', display_role_name);
        if (profile_image) {
            formData.append('profile_image', profile_image);
        }

        const response = await fetch(`${baseURL}/api/sub-contact/create`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};


export const businessDataAPI = async (contact_id: number, business_name: string, business_email: string, business_phone: string, business_landline: string, address: string, city: string, post_code: string, token: string): Promise<CommonApiResponse> => {
    try {
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/business-info/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: JSON.stringify({ contact_id, business_name, business_email, business_phone, business_landline, address, city, post_code }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const createCommercialClientComanyAPI = async (contact_id: number, project_name: string, project_address: string, project_city: string, project_post_code: string,
    company_name: string, company_regno: string, company_email: string, company_phone: string, company_address: string,
    company_city: string, company_post_code: string
): Promise<CommonApiResponse> => {
    try {

        const token = localStorage.getItem('token')
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/commercial-client-project-info/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: JSON.stringify({
                contact_id, project_name, project_address, project_city, project_post_code,
                company_name, company_regno, company_email, company_phone, company_address,
                company_city, company_post_code
            }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const createDomesticClientProjectAPI = async (contact_id: number, address: string, city: string, post_code: string): Promise<CommonApiResponse> => {
    try {

        const token = localStorage.getItem('token')
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/domestic-client-info/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: JSON.stringify({ contact_id, address, city, post_code }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};



/* ************************************************************  update - part *****************************************************************/
export const employeePersonalUpdateAPI = async (personalInfoId: number, first_name: string, last_name: string, email: string, mobile: string, landline: string | null,
    address: string, city: string, post_code: string, profile_image: File, area_id?: number | null): Promise<CommonApiResponse> => {
    try {
        const formData = new FormData();
        formData.append('first_name', first_name);

        if (last_name) {
            formData.append('last_name', last_name);
        }

        if (email) {
            formData.append('email', email);
        }

        if (mobile) {
            formData.append('mobile', mobile);
        }

        if (landline) {
            formData.append('landline', landline);
        }

        if (address) {
            formData.append('address', address);
        }

        if (city) {
            formData.append('city', city);
        }

        if (post_code) {
            formData.append('post_code', post_code);
        }

        if (profile_image) {
            formData.append('profile_image', profile_image);
        }

        if (area_id != null) {
            formData.append('area_id', String(area_id));
        }

        const token = localStorage.getItem('token')
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/personal-info/update/${personalInfoId}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const employeeCompanyUpdateAPI = async (companyInfoId: number, personal_email: string, personal_phone: string, name: string, regno: string, email: string,
    phone: string, address: string, city: string, post_code: string, landline: string): Promise<CommonApiResponse> => {
    try {

        const token = localStorage.getItem('token')
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/company-info/update/${companyInfoId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: JSON.stringify({ personal_email, personal_phone, name, regno, email, phone, address, city, post_code, landline }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const employeeRoleUpdateAPI = async (userRoleInfoId: number, user_role_id: number, display_role_name: string): Promise<CommonApiResponse> => {
    try {

        const token = localStorage.getItem('token')
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/user-role-info/update/${userRoleInfoId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: JSON.stringify({ user_role_id, display_role_name }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const businessDataUpdateAPI = async (businessInfoId: number, business_name: string, business_email: string, business_phone: string, business_landline: string, address: string, city: string, post_code: string): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/business-info/update/${businessInfoId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: JSON.stringify({ business_name, business_email, business_phone, business_landline, address, city, post_code }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const subContactUpdateAPI = async (subContactId: number, employee_type: string, first_name: string, last_name: string, email: string, pimary_phone_no: string, secondary_phone_no: string, user_role_id: number, display_role_name: string, profile_image: File): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        const formData = new FormData();
        formData.append('employee_type', employee_type);
        formData.append('first_name', first_name);
        formData.append('last_name', last_name);
        formData.append('email', email);
        formData.append('pimary_phone_no', pimary_phone_no);
        if (secondary_phone_no) {
            formData.append('secondary_phone_no', secondary_phone_no);
        }
        formData.append('user_role_id', String(user_role_id));
        formData.append('display_role_name', display_role_name);
        if (profile_image) {
            formData.append('profile_image', profile_image);
        }

        const response = await fetch(`${baseURL}/api/sub-contact/update/${subContactId}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

/* */
export const comClientProjectUpdateAPI = async (projectId: number, project_name: string, project_address: string, project_city: string, project_post_code: string, company_name: string,
    company_regno: string, company_email: string, company_phone: string, company_address: string, company_city: string, company_post_code: string): Promise<CommonApiResponse> => {
    try {

        const token = localStorage.getItem('token')
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/commercial-client-project-info/update/${projectId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: JSON.stringify({
                project_name, project_address, project_city, project_post_code, company_name,
                company_regno, company_email, company_phone, company_address, company_city, company_post_code
            }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const domClientProjectUpdateAPI = async (projectId: number, address: string, city: string, post_code: string): Promise<CommonApiResponse> => {
    try {

        const token = localStorage.getItem('token')
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/domestic-client-info/update/${projectId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: JSON.stringify({ address, city, post_code }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

/* ************************************************************  update - part ************************************************************** */


/* ************************************************************  sub contact - delete ************************************************************** */
export const subContactDeleteAPI = async (subContactId: number): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/sub-contact/delete/${subContactId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: JSON.stringify({}),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

/* ************************************************************  client - delete ************************************************************** */
export const deleteCommercialClientProjectAPI = async (projectId: number): Promise<CommonApiResponse> => {
    try {

        const token = localStorage.getItem('token')
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/commercial-client-project/delete/${projectId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: JSON.stringify({}),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const searchEmailService = async (email: string, contact_subtype: string): Promise<ApiResponse> => {
    try {
        const data = {
            email: email,
            contact_subtype: contact_subtype,
        };

        const response = await apiClient.post(`/api/professional-email-check`, data);

        if (response.status === 200) {
            return { status: true, data: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

export const searchCompanyDetailsService = async (company_name: string, company_regno: string, company_email: string,): Promise<ApiResponse> => {
    try {
        const data = {
            company_name: company_name,
            company_regno: company_regno,
            company_email: company_email,
        };
        const response = await apiClient.post(`/api/company-detail-check`, data);

        if (response.status === 200) {
            return { status: true, data: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};


//new updates with Area CURD  18-07-2025

// get area list
export const getAreaForContact = async () => {
    try {
        const response = await apiClient.get(`/api/area-list`);
        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        // Handle error (display error message, log, etc.)
        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

// Area add api
export const createAreaForContact = async (
    area_namex: string,
): Promise<CommonApiResponse> => {
    try {


        // prepare ids for number list
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(
            `${baseURL}/api/area-create`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: FULL_TOKEN,
                },
                body: JSON.stringify({
                    area_name: area_namex,
                }),
            }
        );
        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// update area details
export const updateAreaForContact = async (
    id: number,
    area_namex: string,
): Promise<CommonApiResponse> => {
    try {
        // prepare ids for number list


        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(
            `${baseURL}/api/area-update/${id}`,
            {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: FULL_TOKEN,
                },
                body: JSON.stringify({
                    area_name: area_namex,
                }),
            }
        );

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// delete area
export const deleteAreaForContact = async (
    id: number
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(
            `${baseURL}/api/area-delete/${id}`,
            {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: FULL_TOKEN,
                },
            }
        );

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

